export default "__VITE_ASSET__KhOPhzqs__"